export default "__VITE_ASSET__KbVrtwMF__"